<app-full-page-message
  *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
  *ngIf="!businessId || businessId.length <5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.prepaid_gateway && paidTypes && paymentGatewayStatuses && wrapper">
    <div style="max-width:1200px;" class="banner center">
      <div class="row row_header freeze_col freeze_height">
        <div class="col-3">
          <span>{{localService.languageContent.prepaid_gateway.created_on}}</span>
        </div>
        <div class="col-2">
          <span>{{localService.languageContent.prepaid_gateway.amount}}</span>
        </div>
        <div class="col-3">
          <span>{{localService.languageContent.prepaid_gateway.reason}}</span>
        </div>
        <div class="col-4">
          <span>{{localService.languageContent.prepaid_gateway.status}}</span>
        </div>
      </div>
      <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row" *ngFor="let item of wrapper.items">
          <div class="col-3 en">
            {{item.v1 | localDate}}
          </div>
          <div class="col-2" style="text-align:right;">
            <span class="en">{{item.v2 | number: '1.2-2'}}</span>
          </div>
          <div class="col-3">
            <span>{{localService.getText(paidTypes,item.v4)}}</span>
          </div>
          <div class="col-4">
            <span>{{localService.getText(paymentGatewayStatuses,item.v3)}}</span>
          </div>
        </div>
      </div>
    </div>
    <app-paging [paging]="wrapper.paging" (onPagingRefreshed)="onLoad()"></app-paging>
  </div>
</div>